export default __webpack_public_path__ + "static/media/sync3.27da7d2b.png";